import * as classroomApi from "./classroomApi";
import { SeatLayout } from "@/components/SeatPlan/seatLayout";

export interface ClassroomPersonalisationRequest {
	classroomId: string;
	pinned?: boolean;
	displayName?: string;
	studentSortOrder?: "firstNameAscending" | "lastNameAscending";
}

export const setClassroomPersonalisation = async (
	teacherStableIdV1: string,
	classroomStableIdV1: string,
	pinned: boolean | undefined,
	displayName: string | undefined,
	studentSortOrder: "firstNameAscending" | "lastNameAscending" | "" | undefined
): Promise<object> => {
	const payloadSortOrder = studentSortOrder === "lastNameAscending" ? "lastNameAscending" : "firstNameAscending";
	const payload: ClassroomPersonalisationRequest = {
		classroomId: classroomStableIdV1,
		pinned,
		displayName,
		studentSortOrder: payloadSortOrder,
	};

	return await classroomApi.Post2(`v1/teachers/${teacherStableIdV1}/personalisation`, payload);
};

export interface CreateStudentPersonalisationRequest {
	studentId: string;
	pinned: boolean;
}

export const setStudentPersonalisation: (
	teacherStableIdV1: string,
	classroomStableIdV1: string,
	studentId: string,
	pinned: boolean
) => Promise<unknown> = async (teacherStableIdV1, classroomStableIdV1, studentId, pinned) => {
	const endpoint = `v1/teachers/${teacherStableIdV1}/classrooms/${classroomStableIdV1}/student-personalisation`;
	const body: CreateStudentPersonalisationRequest = {
		studentId,
		pinned,
	};

	return await classroomApi.Put2(endpoint, body);
};

export interface UpdateTileWidthRequest {
	tileWidth: number;
}

export interface UpdateSeatLayoutRequest {
	slots: string[];
	columns: number;
	rows: number;
	tileWidth: number;
}

const layoutEndpoint = (teacherStableIdV1: string, classroomStableIdV1: string, suffix: string) =>
	`v1/teachers/${teacherStableIdV1}/classrooms/${classroomStableIdV1}/personalisation/${suffix}`;

export const setClassroomTileWidth = async (teacherStableIdV1: string, classroomStableIdV1: string, tileWidth: number): Promise<object> => {
	const body: UpdateTileWidthRequest = { tileWidth };
	return await classroomApi.Put2(layoutEndpoint(teacherStableIdV1, classroomStableIdV1, "tile-width"), body);
};

export const setClassroomSeatLayout = async (
	teacherStableIdV1: string,
	classroomStableIdV1: string,
	seatLayout: SeatLayout
): Promise<object> => {
	// Empty seats → "" (backend's slots is []string, no nulls).
	const body: UpdateSeatLayoutRequest = {
		slots: seatLayout.slots.map((s) => s ?? ""),
		columns: seatLayout.columns,
		rows: seatLayout.rows,
		tileWidth: seatLayout.cardWidth,
	};
	return await classroomApi.Put2(layoutEndpoint(teacherStableIdV1, classroomStableIdV1, "layout"), body);
};

export const deleteClassroomSeatLayout = async (teacherStableIdV1: string, classroomStableIdV1: string): Promise<object> => {
	return await classroomApi.DeleteV2(layoutEndpoint(teacherStableIdV1, classroomStableIdV1, "layout"));
};
